import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../basic-features/icon-v2/icon.component";
import * as i3 from "../../../../basic-features/button-v2/button.component";
import * as i4 from "@ngx-translate/core";
/**
 * @deprecated use v3 version of this component instead
 */
function NoEntriesComponent_geaui_button_v2_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-button-v2", 5);
    i0.ɵɵlistener("click", function NoEntriesComponent_geaui_button_v2_8_Template_geaui_button_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.actionTriggered.emit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("preIcon", ctx_r1.actionIcon);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, ctx_r1.actionText));
  }
}
export class NoEntriesComponent {
  titleIcon;
  title;
  infoText;
  actionText;
  actionIcon;
  actionTriggered = new EventEmitter();
  static ɵfac = function NoEntriesComponent_Factory(t) {
    return new (t || NoEntriesComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NoEntriesComponent,
    selectors: [["geaui-no-entries"]],
    inputs: {
      titleIcon: "titleIcon",
      title: "title",
      infoText: "infoText",
      actionText: "actionText",
      actionIcon: "actionIcon"
    },
    outputs: {
      actionTriggered: "actionTriggered"
    },
    decls: 9,
    vars: 8,
    consts: [[1, "content"], ["color", "blue", 3, "file"], [1, "gea-font-heading-32", "title"], [1, "gea-font-body-18", "text"], ["class", "action-button", 3, "preIcon", "click", 4, "ngIf"], [1, "action-button", 3, "click", "preIcon"]],
    template: function NoEntriesComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "geaui-icon-v2", 1);
        i0.ɵɵelementStart(2, "span", 2);
        i0.ɵɵtext(3);
        i0.ɵɵpipe(4, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "span", 3);
        i0.ɵɵtext(6);
        i0.ɵɵpipe(7, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, NoEntriesComponent_geaui_button_v2_8_Template, 3, 4, "geaui-button-v2", 4);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("file", ctx.titleIcon);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 4, ctx.title));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 6, ctx.infoText));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.actionText);
      }
    },
    dependencies: [i1.NgIf, i2.IconComponent, i3.ButtonV2Component, i4.TranslatePipe],
    styles: [".content[_ngcontent-%COMP%]{background-color:var(--geaui-grey-06);width:100%;height:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;overflow:hidden}.content[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{margin:16px 0}.content[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{max-width:495px;text-align:center}.content[_ngcontent-%COMP%]   .action-button[_ngcontent-%COMP%]{margin-top:32px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NoEntriesComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-no-entries',
      template: "<div class=\"content\">\n  <geaui-icon-v2 [file]=\"titleIcon\" color=\"blue\"></geaui-icon-v2>\n  <span class=\"gea-font-heading-32 title\">{{ title | translate }}</span>\n  <span class=\"gea-font-body-18 text\">{{ infoText | translate }}</span>\n  <geaui-button-v2 class=\"action-button\" *ngIf=\"actionText\" [preIcon]=\"actionIcon\" (click)=\"actionTriggered.emit()\">{{\n    actionText | translate\n  }}</geaui-button-v2>\n</div>\n",
      styles: [".content{background-color:var(--geaui-grey-06);width:100%;height:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;overflow:hidden}.content .title{margin:16px 0}.content .text{max-width:495px;text-align:center}.content .action-button{margin-top:32px}\n"]
    }]
  }], null, {
    titleIcon: [{
      type: Input
    }],
    title: [{
      type: Input
    }],
    infoText: [{
      type: Input
    }],
    actionText: [{
      type: Input
    }],
    actionIcon: [{
      type: Input
    }],
    actionTriggered: [{
      type: Output
    }]
  });
})();
